export default {
	data: () => ({
		itemId: 1
	}),
	props: {
		autoScroll: {
			default: false
		}
	},
	methods: {
		setItemId() {
			this.itemId = this.$refs?.select?.focusedIndex == 0 ? 'item_1' : `item_${this.$refs?.select?.focusedIndex}`;
		}
	},
	mounted() {
		this.setItemId();
		if (this.autoScroll) {
			this.$scrollTo(this.$el);
		}
	}
};
